module.exports = __webpack_public_path__ + "static/img/qr-LUCI-Apple.6bf3408.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/qr-LUCI-Apple.png
// module id = OTL9
// module chunks = 3